import { render, staticRenderFns } from "./virtualCompanyBalances.vue?vue&type=template&id=10b3cad0&"
import script from "./virtualCompanyBalances.vue?vue&type=script&lang=js&"
export * from "./virtualCompanyBalances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports